$(document).ready(function() {
    $('.bee-pr-addtocart').on('click', function() {
        setTimeout(() => {
            $('.bee-close-overlay').removeClass('is--visible');
            console.log("Overlay closed after Add to Cart");
        }, 2000); // Adjust delay if needed
    });
});